<template>
      <div class="services block block-bg-gradient block-border-bottom">
      <div class="container">
        <h2 class="block-title">
          Our Services
        </h2>
        <div class="row">
          <div class="col-md-4 text-center">
            <span class="fa-stack fa-5x">
              <i class="fa fa-circle fa-stack-2x text-primary"></i>
              <i class="fa fa-paint-brush fa-stack-1x fa-inverse"></i>
            </span>
            <h4 class="text-weight-strong">
              Custom Coatings
            </h4>
            <p>Coating options include, but are not limited to, in-house dip paints, powder coat, e-coat and zinc plating.</p>
          </div>
          <div class="col-md-4 text-center">
            <span class="fa-stack fa-5x">
              <i class="fa fa-circle fa-stack-2x text-primary"></i>
              <i class="fa fa-truck fa-stack-1x fa-inverse"></i>
            </span>
            <h4 class="text-weight-strong">
                Same Day Shipping
            </h4>
            <p>If ordered by 11 a.m. – we ship garage door torsion spring orders weighing less 300 lbs. the same day!</p>
          </div>
          <div class="col-md-4 text-center">
            <span class="fa-stack fa-5x">
              <i class="fa fa-circle fa-stack-2x text-primary"></i>
              <i class="fa fa-archive fa-stack-1x fa-inverse"></i>
            </span>
            <h4 class="text-weight-strong">
              Value Add Services
            </h4>
            <p>We offer custom packaging, casting installation, shot peening, machining, fatigue testing, to name a few.</p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'HomePageServices'
}
</script>




// WEBPACK FOOTER //
// src/components/HomePageServices.vue